import * as React from "react";
import classes from "./music.module.css"

const Music = () => {
	return (
		<div className={classes.music}>Music</div>
	)
}

export default Music